// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

type SectionSubtitleProps = Readonly<{
  children: React.ReactNode;
  className?: string;
}>;

export function SectionSubtitle({ children, className = '' }: SectionSubtitleProps) {
  return (
    <div className={`text-grey-04 text-base font-normal leading-normal font-sans ${className}`}>
      {children}
    </div>
  );
}
